/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "be38be3ae279ab353ea90d71229e8ce72e8a6233";
